import { useState, useCallback } from 'react';
import HttpHelper from './../utils/HttpHelper';
import { AssessmentQuestion, AssessmentQuestionType } from './../utils/assessmentsQuestions';


const useFileHandlers = () => {
    const [fileDeleted, setFileDeleted] = useState<boolean[]>([]);
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    const handleFileUpload = useCallback(async (index: number, file: File | null, assessmentId: string, questions: AssessmentQuestion[], setQuestions: React.Dispatch<React.SetStateAction<AssessmentQuestion[]>>) => {

        const question = questions[index];
        if (question.id === null) {
            console.error("Question ID is null, cannot upload file.");
            setModalOpen(true);
            return;
        }

        if (!file) {
            console.error("No file selected.");
            return;
        }
        const updatedQuestions = [...questions];
        updatedQuestions[index] = { ...updatedQuestions[index], file: file };
        setQuestions(updatedQuestions);
        console.log(updatedQuestions[index]);
        console.log('File upload process for existing question');
        let formData = new FormData();
        formData.append('file', file);
        try {
            const fileUploadEndpoint = `assessments/${assessmentId}/question/${question.id}/file/upload`;
            await HttpHelper.putFormDate(fileUploadEndpoint, formData, {
            });
            console.log('File uploaded successfully');
        } catch (error) {
            console.error('Error uploading file:', error);
    }  }, []);

const handleDeleteFile = useCallback(async (index: number, assessmentId: string, questions: AssessmentQuestion[], setQuestions: React.Dispatch<React.SetStateAction<AssessmentQuestion[]>>) => {
    const question = questions[index];
    if (question.id === null) {
        setModalOpen(true);
    } else {
        const updatedQuestions = [...questions];
        updatedQuestions[index] = { ...question, file: null };
        setQuestions(updatedQuestions);

        try {
            const fileUploadEndpoint = `assessments/${assessmentId}/question/${question.id}/file/delete`;
            await HttpHelper.delete(fileUploadEndpoint);
            console.log('File deleted successfully');
        } catch (error) {
            console.error('Error deleting file:', error);
        }
    }
}, [fileDeleted]);


return { handleFileUpload, handleDeleteFile, fileDeleted, setFileDeleted, modalOpen, setModalOpen };
};

export default useFileHandlers;
